import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

export default () => {
  return Object.freeze({
    getAppUsers: async (userId, appId) => {
      const options = createRequestOptions({ userId, appId });

      const result = await fetch(Config.serverUrl + "/GetAppUsers", options);
      const response = await result.json();

      return get(response, "response");
    },
    removeAppUser: async (userId, appId, appUserId) => {
      const options = createRequestOptions({ userId, appId, appUserId });

      const result = await fetch(Config.serverUrl + "/RemoveAppUser", options);
      const response = await result.json();

      return get(response, "response");
    },
    enrollAppUser: async (appId, appUserId) => {
      const options = createRequestOptions({ appId, appUserId });

      const result = await fetch(Config.serverUrl + "/EnrollAppUser", options);
      const response = await result.json();

      return get(response, "response");
    },
    dischargeAppUser: async (userId, appId, appUserId) => {
      const options = createRequestOptions({ userId, appId, appUserId });

      const result = await fetch(
        Config.serverUrl + "/DischargeAppUser",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    dischargeAppUserNoAccess: async (userId, appId, appUserId) => {
      const options = createRequestOptions({ userId, appId, appUserId });

      const result = await fetch(
        Config.serverUrl + "/DischargeAppUserNoAccess",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },

    getUserActivityForCustomApp: async (userId, customAppId) => {
      const options = createRequestOptions({
        userId,
        customAppId,
      });

      const result = await fetch(
        Config.mobileServerUrl + "/GetUserActivityForCustomApp",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    deleteUserActivityForCustomApp: async (userId, activityId, customAppId) => {
      const options = createRequestOptions({
        userId,
        activityId,
        customAppId,
      });

      const result = await fetch(
        Config.mobileServerUrl + "/DeleteUserActivityForCustomApp",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
    moveCustomAppToNewChannel: async (
      userId,
      customAppId,
      patientId,
      newAppId
    ) => {
      const options = createRequestOptions({
        userId,
        customAppId,
        patientId,
        newAppId,
      });

      const result = await fetch(
        Config.serverUrl + "/MoveCustomAppToNewChannel",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
  });
};



// WEBPACK FOOTER //
// ./src/services/appusers.js